<template lang="pug">
    v-container(pa-0)
        v-layout(xs12 md6 offset-md3)
            v-flex(style='position: relative')
                v-card(style='max-height: 100%;')
                    v-flex(d-flex  column align-center style="position:relative")
                        img(
                            style='max-height: 350px; max-width: 700px; width: 100%; object-fit: cover; overflow: hidden;'
                            :src='item.image'
                            )
                    v-layout( :px-5="!isMobile")

                        div.share-links
                            v-layout(column).share-links__container

                                ShareNetwork(network='facebook' :url='metaParams.url'  :description='metaParams.title' :quote='metaParams.title' hashtags='scenefinder')
                                    v-btn(flat='', icon='', color='blue lighten-2')
                                        v-icon(data-network="facebook" class='button share-button facebook-share-button' :medium='isMobile' :x-large='!isMobile' color="blue") mdi-facebook
                                ShareNetwork(network='twitter' :url='metaParams.url' :description='metaParams.title' :quote='metaParams.title' hashtags='scenefinder' twitter-user='scenefinder')
                                    v-btn(flat='', icon='', color='blue lighten-2')
                                        v-icon(data-network="twitter" class='button share-button twitter-share-button' :medium='isMobile' :x-large='!isMobile' color="light-blue") mdi-twitter
                                ShareNetwork(network='whatsapp' :url='metaParams.url' :description='metaParams.title' :quote='metaParams.title' hashtags='scenefinder')
                                    v-btn(flat='', icon='', color='green lighten-2')
                                        v-icon(data-network="twitter" class='button share-button whatsapp-share-button' :medium='isMobile' :x-large='!isMobile' color="light-green") mdi-whatsapp

                                <!--v-icon(data-network="facebook" class='button share-button facebook-share-button' medium color="blue") mdi-facebook-box-->
                                <!--v-icon(data-network="twitter" class='button share-button twitter-share-button' medium color="light-blue") mdi-twitter-box-->
                                <!--v-icon(data-network="pinterest" class='button share-button pinterest-share-button' medium color="red") mdi-pinterest-->
                        v-flex.post-content(v-if='isMobile' style='flex:1;')
                            v-card-title
                                h1 {{item.title}}
                            v-slide-y-transition
                                v-card-text.ql-editor(v-html="content")
                        v-flex.post-content.mt-4(v-if='!isMobile' style='flex:1;')
                            v-card-title
                                .display-1(style="font-weight: 600") {{item.title}}
                            v-skeleton-loader.mx-auto(v-if = 'isLoading' max-width="300" type="card")
                            v-card-text.ql-editor( v-else  v-html="item.content")
</template>
<script>
  // import axios from 'axios'
  export default {
    props: {
      currentContext: String,
    },
    data () {
      return {
        content: '',
        fab: true,
        isLoading: false,
        model: {
          id: null,
          category: null,
          type: null,
          title: null,
          content: null,
          image: null,
        },
        context: 'posts',
      }
    },
    computed: {
      metaParams () {
        const data = {
          title: 'Scene Finder - ' + this.item.title,
          description: 'Read more',
          image: this.item.image,
          app: 'Scene Finder',
          url: 'https://us-central1-scenefinder-dev.cloudfunctions.net/cmsFunctions/?id=' + this.item.id + '&type=' + this.currentContext,

        }

        return data
      },
      item () {
        return this.$store.getters['cms/getCurrentPost']
        // switch (this.currentContext) {
        //   case 'posts' :
        //     return this.$store.getters['cms/getCurrentPost']
        //   case 'static' :
        //     return this.$store.getters['cms/getStatic']
        //   case 'faq' :
        //     return this.$store.getters['cms/getStatic']
        //   default:
        //     return this.$store.getters['cms/getCurrentPost']
        // }
      },
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    watch: {
      // item () {
      //   const vm = this
      //   vm.isLoading = true
      //   const contentSource = vm.item.content
      //   axios.get(`${contentSource}`).then(response => (vm.content = response.data)).then(vm.isLoading = false)
      // },
    },
    created () {
      const vm = this
      var id = vm.$route.params.id
      if (id) { vm.$store.dispatch('cms/getItem', { context: this.context, id: id }) }
    },
    mounted () {
      // const vm = this
      // const contentSource = vm.item.content
      // axios.get(`${contentSource}`).then(response => (vm.content = response.data)).then(// console.log(vm.content))
    },
    methods: {
    },
  }
</script>
<style lang="scss" scoped>
    .v-speed-dial--bottom.v-speed-dial--absolute{
        bottom:0 !Important;
    }
    .share-links{
      display:flex;
      align-items: center;
      flex-direction:column;
      padding-top: 5px;
      min-width: 50px;
      &__container {
        max-height: 200px;
        position: sticky;
        margin-top: 80px;
        top: 80px;
      }
    }
    @media (min-width: 1024px) {
      .share-links{
        padding-top: 25px;
      }
    }
    //comment dialog section

    .dialog-close{

      top: 10%;
      right: 10px;

    }
    .v-dialog--fullscreen {
      background: rgba(#000,0.6);
      overflow: hidden;
      .comment-container{
        background:#fff;
        max-height:80%;
        margin:0;
        margin-top: 20% ;
        overflow:hidden;
        display: flex;
        flex-direction: column;;
        position: absolute;
        bottom:0;
      }
      .comment-scroller{
        overflow-y: auto;
        flex:6;
      }
      .post-comments {
        .v-list__tile__content{
          overflow: visible ;
          word-break: break-word;
        }
        .v-list__tile {
          min-height: 88px;
          height: auto !important;
          align-items: flex-start;
          padding: 1rem;
        }
        .v-list__tile__avatar{
          margin-top: 5px;
        }
        .tailed-comment{

          background: #f7f7f7;
          padding: 15px 10px;
          border-radius: 10px;
          position: relative;
          overflow: unset;
          z-index: 0;

          .icon:before {
            font-family: sans-serif;
          }
          &:before{
            z-index: -1;
            content:'';
            position: absolute;
            display: block;
            height: 20px;
            width: 20px;
            background: #f7f7f7;
            transform: rotate(45deg);
            top: 2px;
            left: -1px;
            border-radius: 10px 0 10px 0;

          }
        }

      }

    }
    .comment-buttons{
    //transform: scale(0.8);
    }
    .comment-textarea{

      opacity: 0.95;
      max-height:80px;
      min-height: 70px;
      .v-input__append-inner{
        margin: 0 5px 0 0 !important;
      //transform: scale(0.8);
        display: flex;
        align-items: center;
        max-width: 125px;
      }

      .v-input__slot{
        padding-right: 0 !important;
      }
      .v-input__control{
        background:#fff;
      }
    }
    // end of comment dialog section

    .white-bg{
      background: white;
    }

    .post-action-button{
      font-weight:bold;
      margin: 5px;
      min-width: 0;
      text-transform: Capitalize;
      max-height: 26px;
    }

    .post-content > div{
      padding-left: 5px;
      &.v-card__title,
      &.ql-editor {
        padding-top: 5px;
      }
    }

    .share-links{
      display:flex;
      align-items: center;
      flex-direction:column;
      max-width: 36px;
      padding-top: 5px;
    }

    .post-time-stamp{
      font-size: 11px;
    }

    .Masthead{
      z-index: 0 !important;
      min-height: 230px;
    }
    .parallax-container {
      position: relative;
    }
    .v-tooltip__content{
      z-index: 999 !important;
    }
    .v-speed-dial__list{
      .v-btn{
        margin-top:0;
        margin-bottom:0;
      }
    }

</style>
